import React, { useState } from 'react';

/* ── Password strength ───────────────────────────────────────────────────────── */
export function pwStrength(pw) {
  let s = 0;
  if (pw.length >= 8) s++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(s, 4);
}

export const PW_STR_COLOR = ['', '#f3677e', '#f0a23b', '#e0c54a', '#4ade80'];

export const PW_STR_LABEL = ['', 'Weak', 'Fair', 'Good', 'Strong'];

export const EyeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4 20 20" />
    <path d="M9.6 5.9A9.4 9.4 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a16 16 0 0 1-2.7 3.4" />
    <path d="M6.3 7.8A15.7 15.7 0 0 0 2.5 12S6 18.5 12 18.5a9 9 0 0 0 3-.5" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </svg>
);

export const PasswordInput = ({ value, onChange, placeholder, autoComplete, disabled, autoFocus, style }) => {
  const [reveal, setReveal] = useState(false);
  return (
    <div className="pw-input-wrap" style={style}>
      <input
        type={reveal ? 'text' : 'password'}
        className="privacy-password-input"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      <button type="button" className="pw-eye-btn" tabIndex={-1} onClick={() => setReveal((r) => !r)} aria-label="Toggle password visibility">
        {reveal ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
};

export const PasswordStrengthMeter = ({ password }) => {
  if (!password) return null;
  const s = pwStrength(password);
  return (
    <>
      <div className="pw-strength-meter">
        {[1, 2, 3, 4].map((i) => (
          <i key={i} style={{ background: i <= s ? PW_STR_COLOR[s] : undefined }} />
        ))}
      </div>
      <span className="pw-strength-label" style={{ color: PW_STR_COLOR[s] || 'var(--text-3, #71717a)' }}>
        {PW_STR_LABEL[s] || 'Too short'} password
      </span>
    </>
  );
};
